import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function Redirect_invitation() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/communications'); 
  }, [navigate]); 

  return null; 
}
